export type PopupTextPart = {
  text: string;
  bold?: boolean;
};

export type AnalyticsPopup = {
  title: string;
  index: string;
  separator: string;
  lead: string;
  points?: string[];
  pointEnds?: string[];
  pointsMarker?: 'dash' | 'number' | 'decimal';
  note?: PopupTextPart[];
  advantagesTitle: string;
  advantages: string[];
  advantageEnds?: string[];
  advantagesMarker?: 'dash' | 'number' | 'decimal';
  leadOnNextLine?: boolean;
};

export type ServiceDirection = {
  title: string;
  popup?: AnalyticsPopup;
};

export const ANALYTICS_DIRECTIONS: ServiceDirection[] = [
  {
    title: 'Индивидуальные аналитические исследования',
    popup: {
      title: 'Индивидуальные аналитические исследования',
      index: '1.',
      separator: ' – ',
      lead: 'аналитические материалы, в рамках которых может быть проведено исследование по следующим параметрам (не более 3 рынков в 1 заявке): макроэкономический анализ рынка, анализ торговых потоков в отношении заявленных товаров на рынке, обзор тарифных и нетарифных барьеров, условий доступа на рынок и востребованность товаров на выбранном рынке, в том числе в рамках инфраструктурных проектов',
      note: [
        { text: 'Срок подготовки индивидуального аналитического исследования составляет ' },
        { text: 'не более 28 рабочих дней', bold: true },
        { text: '.' },
      ],
      advantagesTitle: 'Преимущества получения индивидуальной аналитики:',
      advantagesMarker: 'number',
      advantages: [
        'Возможность оценить перспективность внешнеэкономической деятельности на выбранном направлении',
        'Заблаговременная адаптация продукции к требованиям зарубежного рынка',
        'Минимизация расходов и временных издержек компании на экспортном направлении',
        'Возможность выявить скрытые риски и перспективные точки роста экспорта',
      ],
      advantageEnds: [';', ';', ';', '.'],
    },
  },
  {
    title: 'Индивидуальные экспортные стратегии',
    popup: {
      title: 'Индивидуальные экспортные стратегии',
      index: '2.',
      separator: ' – ',
      lead: 'исследование рынков целевых зарубежных стран, согласованных с получателем меры поддержки, содержащее рекомендации по продвижению продукции на выбранном рынке. Также в рамках индивидуальной экспортной стратегии оказываются следующие услуги:',
      points: [
        'Подготовка адаптированных презентационных материалов на иностранном языке',
        'Разработка проекта коммерческого предложения',
        'Подготовка индивидуального перечня потенциальных целевых зарубежных партнеров для каждого получателя меры поддержки',
        'Организация и проведение индивидуальных установочных встреч для экспортно ориентированных субъектов промышленной деятельности и агропромышленного комплекса города Москвы на рынок целевой зарубежной страны в онлайн-формате',
      ],
      pointEnds: [';', ';', ';', '.'],
      pointsMarker: 'dash',
      note: [
        { text: 'Срок подготовки индивидуальной экспортной стратегии составляет ' },
        { text: 'не более 90 рабочих дней', bold: true },
        { text: '.' },
      ],
      advantagesTitle: 'Основные преимущества разработки экспортной стратегии:',
      advantagesMarker: 'number',
      advantages: [
        'Минимизация юридических и финансовых рисков',
        'Повышение информированности о рынке',
        'Оптимизация затрат',
        'Укрепление конкурентных преимуществ компании',
        'Повышение эффективности внутренних процессов',
      ],
    },
  },
  {
    title: 'Отраслевые и страновые стратегии и дайджесты',
    popup: {
      title: 'Отраслевые и страновые стратегии и дайджесты',
      index: '3.',
      separator: ' – ',
      lead: 'справочные материалы, подготовленные экспертами АНО «Моспром», в разрезе ключевых стран-партнеров или основных экспортно ориентированных отраслей московской промышленности.',
      points: [
        'Страновые стратегии включают в себя: обзор экономики страны, правовой системы, особенности привлечения инвестиций, договорные аспекты и основные условия деятельности на рынке и т.д.',
        'Отраслевые стратегии включают в себя: обзор конкурентных преимуществ московских промышленных товаров на зарубежных рынках, перспективы применения в инфраструктурных проектах и барьеры рынка и т.д.',
      ],
      pointsMarker: 'dash',
      advantagesTitle: 'Основные преимущества отраслевых и страновых стратегий АНО «Моспром»:',
      advantagesMarker: 'number',
      advantages: [
        'Повышение осведомленности об актуальных условиях ведения бизнеса на зарубежных рынках',
        'Выявление потенциально перспективных рынков для экспорта',
        'Снижение рисков при экспорте с учетом национальных требований',
      ],
    },
  },
  {
    title: 'Практико-ориентированные материалы',
    popup: {
      title: 'Практико-ориентированные материалы',
      index: '4.',
      separator: ' - ',
      lead: 'справочные рекомендации, чек-листы и полезные исследования, подготовленные экспертами АНО «Моспром», по наиболее востребованным областям ВЭД (проверка зарубежных контрагентов, договор ВЭД, логистика, расчеты)',
      advantagesTitle: 'Основные преимущества практико-ориентированных материалов АНО «Моспром»:',
      advantagesMarker: 'number',
      advantages: [
        'Минимизация рисков и ошибок при осуществлении ВЭД',
        'Получение новой информации о возможностях для московских компаний в сфере ВЭД',
        'Адаптация внутренних процессов компании к качественной трансформации ВЭД в условиях санкционных ограничений',
      ],
    },
  },
];
